import { ClientBusinessPartialModel } from 'app/client/clientBusiness/models/ClientBusiness';
import { Field, useFormikContext } from 'formik';
import Button from 'shared/components/Button';
import FormField from 'shared/components/form/FormField';
import FormikInput from 'shared/components/form/FormikInput';
import StyledAutocomplete from 'shared/components/StyledAutocomplete';
import * as Yup from 'yup';
import { EventoWizardFormValues } from './eventoWizardTypes';

export const generalDataFields = [
  'name',
  'description',
  'businessClientId',
  'isActive'
] as const;

export const generalDataSchema = Yup.object().shape({
  name: Yup.string()
    .required('El nombre es requerido')
    .min(3, 'El nombre no puede tener menos de 3 caracteres'),
  description: Yup.string(),
  businessClientId: Yup.number().nullable().required('El cliente es requerido'),
  isActive: Yup.boolean()
});

interface Props {
  clients: ClientBusinessPartialModel[];
  onNext: () => void;
}

const EventoGeneralDataStep = ({ clients, onNext }: Props) => {
  const { values, errors, touched, setFieldValue } =
    useFormikContext<EventoWizardFormValues>();

  return (
    <div className="flex max-w-lg flex-col gap-5">
      <h2 className="text-xl font-semibold text-ink dark:text-ink-dark">
        Datos generales
      </h2>

      <FormField
        label="Cliente"
        error={touched.businessClientId && errors.businessClientId}
      >
        <StyledAutocomplete<ClientBusinessPartialModel>
          options={clients}
          value={
            clients.find((client) => client.id === values.businessClientId) ??
            null
          }
          getOptionLabel={(client) => client?.fantasyName ?? ''}
          onChange={(value) =>
            setFieldValue('businessClientId', value ? value.id : null)
          }
          placeholder="Seleccionar cliente"
        />
      </FormField>

      <FormikInput
        name="name"
        label="Nombre del evento"
        placeholder="Ej: Concierto Coldplay 2026"
      />

      <FormikInput
        name="description"
        label="Descripción"
        multiline
        rows={3}
        placeholder="Detalles adicionales del evento (opcional)"
      />

      <label className="flex items-center gap-3">
        <Field
          type="checkbox"
          name="isActive"
          className="h-4 w-4 accent-secondary-500"
        />
        <span className="text-sm text-ink dark:text-ink-dark">
          Evento activo
        </span>
      </label>

      <div className="flex justify-end pt-4">
        <Button type="button" onClick={onNext}>
          Siguiente
        </Button>
      </div>
    </div>
  );
};

export default EventoGeneralDataStep;
